import React, { lazy } from 'react';
import styled from 'styled-components';
import ICellProps from '../ICellProps';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import wkx from 'wkx';
import MapForm from '../../../../../MapForm';
import { Buffer } from 'buffer';
import { TooltipHost } from 'office-ui-fabric-react';

interface IProps extends ICellProps {}

interface IState {
  isMapShowing: boolean;
}

const DataBlock = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  font-size: 12px;
  align-items: center;
  padding: 0 10px;
  cursor: pointer;
  color: #003a72;
`;

class Polygon extends React.Component<IProps> {
  state = {
    isMapShowing: false,
  };

  onShowEditDlg = (): void => {
    this.setState({ isMapShowing: true });
  };

  onCloseEditDlg = (): void => {
    this.setState({ isMapShowing: false });
  };

  onAccept = (data: any): void => {
    try {
      const json = {
        type: 'LineString',
        coordinates: data.map((point: any) => [point.lon, point.lat]),
      };
      const geom = wkx.Geometry.parseGeoJSON(json);
      this.props.onChange && this.props.onChange(geom.toEwkb().toString('hex'));
    } catch (e) {
      console.log('error', e);
    }

    this.setState({ isMapShowing: false });
  };

  getTrajectoryPoints = (): { lon: number; lat: number }[] => {
    const res: { lon: number; lat: number }[] = [];
    try {
      const wkbBuffer = new Buffer(this.props.value, 'hex');
      const geom = wkx.Geometry.parse(wkbBuffer);
      const json = geom.toGeoJSON() as any;
      if (json && json.coordinates) {
        return json.coordinates.map((el: [number, number]) => ({
          lat: el[1],
          lon: el[0],
        }));
      }
    } catch (e) {
      console.log(e);
    }
    return res;
  };

  render() {
    const { value } = this.props;
    return (
      <DataBlock onClick={!this.props.readonly ? this.onShowEditDlg : undefined}>
        {value ? 'Заполнено' : 'Пусто'}&nbsp;
        <TooltipHost content="Недостаточно прав доступа" id={'showTrajectoryMap'} calloutProps={{ gapSpace: 0 }} hidden={!this.props.readonly}>
          <Icon iconName={'Edit'} />
        </TooltipHost>
        {this.state.isMapShowing && (
          <MapForm
            {...(this.props as any)}
            point={undefined}
            trajectory={this.getTrajectoryPoints()}
            onClose={this.onCloseEditDlg}
            onAccept={this.onAccept}
          />
        )}
      </DataBlock>
    );
  }
}

export default Polygon;
